// extracted by mini-css-extract-plugin
export var activityContainer = "_ms-0";
export var typingIndicatorContainer = "_ms-1";
export var typingIndicatorDot = "_ms-2";
export var wave = "_ms-3";